/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_A1Inputs */

const en_formatter_faq_a1 = /** @type {(inputs: Formatter_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two spaces, four spaces, or a tab character. The tab option emits a real tab, so the visible width follows your editor setting rather than being fixed at one space.`)
};

const ko_formatter_faq_a1 = /** @type {(inputs: Formatter_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2칸, 4칸, 또는 탭 문자입니다. 탭 옵션은 실제 탭을 출력하므로, 보이는 너비는 한 칸으로 고정되지 않고 에디터 설정에 따릅니다.`)
};

const ja_formatter_faq_a1 = /** @type {(inputs: Formatter_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 スペース、4 スペース、またはタブ文字です。タブオプションは実際のタブを出力するので、見た目の幅は 1 スペースに固定されず、エディタの設定に従います。`)
};

/**
* | output |
* | --- |
* | "Two spaces, four spaces, or a tab character. The tab option emits a real tab, so the visible width follows your editor setting rather than being fixed at one..." |
*
* @param {Formatter_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_a1 = /** @type {((inputs?: Formatter_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_a1(inputs)
	if (locale === "ko") return ko_formatter_faq_a1(inputs)
	return ja_formatter_faq_a1(inputs)
});